// extracted by mini-css-extract-plugin
module.exports = {"container":"Player_container__I9vBu"};